import useFetch from 'use-http'
import { useMemo, useEffect, useState } from 'react'
import { Box, Text, Button } from 'theme-ui'
import { useRouter } from 'next/navigation'
import Image from 'next/image'

import { apiUrl } from '../environment'
import Twitter from '../components/icons/Twitter'
import AuthenticationLayout from '../components/AuthenticationLayout'
import FullScreenLoader from '../components/FullScreenLoader'
import FullScreenError from '../components/FullScreenError'

export default function Connect() {
    let query = useQuery()
    let isSignIn = query.get('type') === 'signin'
    let [cookieEnabled, setCookieEnabled] = useState(false)
    let [cookieLoading, setCookieLoading] = useState(true)

    useEffect(() => {
        console.log(navigator)
        if (navigator) {
            setCookieEnabled(navigator.cookieEnabled || false)
        }
        setCookieLoading(false)
    }, [])

    const { loading, error, data } = useFetch(
        `${apiUrl}/twitter/authenticate`,
        []
    )

    if (loading || cookieLoading) {
        return <FullScreenLoader />
    }

    if (!cookieEnabled) {
        return (
            <FullScreenError error="Cookies needs to be enabled for this website to function. Cookies are often disabled in private/incognito mode." />
        )
    }

    if (error) {
        return <FullScreenError />
    }

    const content = (
        <Box sx={{ textAlign: ['center', 'center', 'left'] }}>
            <Text
                as="h1"
                sx={{
                    fontFamily: 'heading',
                    fontSize: [7, 7, 9],
                    lineHeight: 1.1,
                    pr: [0, 0, 4],
                    pb: [5],
                }}
            >
                {isSignIn ? 'Welcome back' : 'Here’s your tiny invitation'}
            </Text>
            <Text as="p" sx={{ fontSize: [3, 3, 3], fontWeight: 300, pb: 5 }}>
                {isSignIn
                    ? 'To check out your ranking or submit your wallet (if whitelisted) please click the button below.'
                    : 'To join our discord server we need to analyse your twitter account to keep bots out and keep our giveaways fair and square. Click below to continue'}
            </Text>

            <Button as="a" href={data.url}>
                <Box sx={{ display: 'inline-flex' }} mr={2}>
                    <Twitter />
                </Box>
                Sign in with Twitter
            </Button>

            <Text as="p" sx={{ fontSize: 1, fontWeight: 300, pt: 5 }}>
                We only ask read-only access and will never post anything in
                your name
            </Text>
        </Box>
    )

    const side = (
        <Box p={5}>
            <Box
                sx={{
                    borderRadius: 1,
                    overflow: 'hidden',
                    position: 'relative',
                    maxWidth: '100%',
                }}
            >
                <Image
                    alt="Purple ticket design with character portrait, '1 X DISCORD TICKET' text, barcode, and Discord logo."
                    src="/pages/connect/ticket-pending.png"
                    fill
                    sizes={678}
                    quality={95}
                />
            </Box>

            <Image
                src={ticketPending}
                alt="Purple ticket design with character portrait, '1 X DISCORD TICKET' text, barcode, and Discord logo."
                sx={{
                    maxWidth: '100%',
                }}
                srcSet={`${ticketPending} 1x, ${ticketPending2x} 2x`}
            />
        </Box>
    )
    return (
        <AuthenticationLayout content={content} side={side} color="#381B51" />
    )
}

function useQuery() {
    const { search } = useRouter()
    return useMemo(() => new URLSearchParams(search), [search])
}
